import React, {Fragment, Component, ReactElement} from 'react';
import {renderRoutes} from 'react-router-config';
import {Breadcrumbs, Sidebar} from 'frontend-core';
import {AppBar, IconButton, Toolbar, WithStyles, withStyles} from '@material-ui/core';
import {Menu} from '@material-ui/icons';
import {Link, RouteComponentProps} from 'react-router-dom';
import {CustomRouteConfig} from 'frontend-core/build/components/sidebar/sidebar';
import {Theme} from '../../contexts/theme';
import {ViewModeContext} from '../../contexts/viewMode';
import {ViewMode} from '../../models/viewMode';
import {AppState} from '../../containers/App';
import styles from './main.style';
import MainUser from './main.user';
import MainViewMode from './main.viewMode';
import MainTheme from './main.theme';

export interface Props extends RouteComponentProps {
  route: CustomRouteConfig;
  user?: AppState['user'];
}

interface State {
  hideMenu: boolean;
}

class Main extends Component<Props & WithStyles<typeof styles>, State> {
  state = {
    hideMenu: localStorage.getItem('hideMenu') === 'true'
  };

  toggleMenu = () => {
    this.setState({hideMenu: !this.state.hideMenu}, () => {
      localStorage.setItem('hideMenu', this.state.hideMenu.toString());
    });
  };

  render() {
    const {route, classes} = this.props;
    const {hideMenu} = this.state;

    return (
      <ViewModeContext.Consumer>
        {({viewMode}): ReactElement => {
          const slim = viewMode === ViewMode.SLIM;
          return (
            <Fragment>
              <AppBar position='absolute' className={classes.header}>
                <Toolbar
                  classes={{
                    root: `${classes.headerToolbar} ${slim ? classes.headerToolbarSlim : ''}`
                  }}
                >
                  <div className={classes.headerLeft}>
                    <IconButton color='inherit' onClick={this.toggleMenu}>
                      <Menu />
                    </IconButton>
                    <Theme.Consumer>
                      {({title}) => (
                        <Link className={classes.headerText} to='/'>
                          {<span>{title || 'Интеграционная шина региона'}</span>}
                        </Link>
                      )}
                    </Theme.Consumer>
                  </div>

                  <div className={classes.headerRight}>
                    <MainViewMode />
                    <MainTheme />
                    {this.props.user && <MainUser {...this.props} />}
                  </div>
                </Toolbar>
              </AppBar>

              <div className={`${classes.content} ${slim ? classes.contentSlim : ''}`}>
                <Sidebar route={route} hide={hideMenu} />
                <div className={`${classes.main} ${hideMenu ? classes.mainMax : ''}`}>
                  {!!route && (
                    <>
                      <Breadcrumbs routes={route.routes} slim />
                      {renderRoutes(route.routes)}
                    </>
                  )}
                </div>
              </div>
            </Fragment>
          );
        }}
      </ViewModeContext.Consumer>
    );
  }
}

export default withStyles(styles, {name: 'Main'})(Main);
